module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('div', {
    staticClass: "col-auto concept-icon",
    attrs: {
      "draggable": _vm.isBoardEditable
    },
    on: {
      "click": function($event) {
        _vm.tooltipShown = !_vm.tooltipShown
      },
      "dragstart": _vm.dragstart,
      "dragend": _vm.dragend
    }
  }, [_c('img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    attrs: {
      "src": _vm.icon,
      "alt": _vm.cardInfo.Tooltip_fr,
      "title": _vm.cardInfo.Tooltip_fr
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tooltipShown),
      expression: "tooltipShown"
    }]
  }, [_c('div', {
    staticClass: "container-fluid tooltip-row"
  }, [_c('b-row', {
    staticClass: "row align-items-center tooltip-row"
  }, [_c('div', {
    staticClass: "col-auto px-1 px-sm-2"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.cardInfo.Tooltip_fr))])]), _vm._v(" "), (_vm.addOrRemove == 'add' && _vm.isBoardEditable) ? _c('div', {
    staticClass: "col-auto px-1 px-sm-2 icon-pointer",
    on: {
      "click": function($event) {
        _vm.tooltipShown = !_vm.tooltipShown;
        _vm.changeIcon('add-icon', _vm.cardInfo)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "color": _vm.selectedColor,
      "icon": "plus-circle",
      "size": "2x"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addOrRemove == 'remove' && _vm.isBoardEditable) ? _c('div', {
    staticClass: "col-auto px-1 px-sm-2 icon-pointer",
    on: {
      "click": function($event) {
        _vm.tooltipShown = !_vm.tooltipShown;
        _vm.changeIcon('remove-icon', _vm.cardInfo)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "color": _vm.iconColor,
      "icon": "trash",
      "size": "2x"
    }
  })], 1) : _vm._e()])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f01ce79","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = OEZw
// module chunks = 1